import React from "react";
import "./speakerbio.css";
import file from "../../assets/pdf-white.svg";
import link from "../../assets/link.svg";
import { saveResourceStats } from "../../services/event/resourceStats";
import axios from "axios";

const RelatedContent: React.FC<any> = ({
  relatedContent,
  hyperLinks,
  eventId,
  email
}) => {

  const handleLinkClick = async (content: any) => {
    window.open(content.url, "_blank");
    if (email) {
      try {
        await saveResourceStats(
          eventId,
          email,
          content.id ? content.id : content._id,
          content.name? content.name : content.title,
          content.url
        );
      } catch (error) {
        if (axios.isAxiosError(error) && error.response && error.response.status !== 409) {
          console.error("Error saving resource stats:", error);
        }
      }
    } 
  };

  return (
    <div className="content-wrapper">
      <div className="header-content">Related Content</div>
      <hr />
      <div className="inner-content-wrapper">
        {relatedContent.map((content: any, index: any) => (
          <div className="speakers" key={index}>
            <div className="pdf-wrapper">
              <a
                href="#"
                onClick={(e) => {
                  e.preventDefault(); // Prevent immediate navigation
                  handleLinkClick(content);
                }}
                target="_blank"
                rel="noopener noreferrer"
                className="file-logo-wrapper"
                aria-label={`Open ${content.name} in a new tab`}
              >
                <img src={file} alt="file-logo" />
              </a>
              <a
                href="#"
                onClick={(e) => {
                  e.preventDefault(); // Prevent immediate navigation
                  handleLinkClick(content);
                }}
                target="_blank"
                rel="noopener noreferrer"
                className="pdf-btn"
              >
                {content.name}
              </a>
            </div>
          </div>
        ))}
        {hyperLinks.map((content: any, index: any) => (
          <div className="speakers" key={index}>
            <div className="pdf-wrapper">
            <a
                href="#"
                onClick={(e) => {
                  e.preventDefault(); // Prevent immediate navigation
                  handleLinkClick(content);
                }}
                target="_blank"
                rel="noopener noreferrer"
                className="file-logo-wrapper"
                aria-label={`Open ${content.name} in a new tab`}
              >
                <img src={link} alt="file-logo" />
              </a>
              <a
                href="#"
                onClick={(e) => {
                  e.preventDefault();
                  handleLinkClick(content);
                }}
                target="_blank"
                rel="noopener noreferrer"
                className="pdf-btn"
              >
                {content.title}
              </a>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default RelatedContent;
